import { Dialog, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { ContactDialogContent } from './ContactDialogContent';
import { InfoDialogContent } from './InfoDialog/InfoDialogContent';
import { VideoDialogContent } from './VideoDialogContent';
import { DialogContentType } from './QuickMenu';

const btnSizeMobile = 60;

export const useQuickMenuStyles = makeStyles((theme: Theme) => ({
	dialogPaper: {
		// minHeight: '80vh',
		marginRight: btnSizeMobile + theme.spacing(2) + 32,
		width: `calc(100% - ${2 * 32 + btnSizeMobile + theme.spacing(2)}px)`,
	},
}));

export const QuickMenuDialog: React.FC<{
	open: boolean;
	activeEntry: DialogContentType | null;
	handleClose(): void;
}> = ({ open, activeEntry, handleClose }) => {

	const classes = useQuickMenuStyles();

	const getDialogContent = (type: DialogContentType | null) => {
		switch (type) {
			case DialogContentType.VIDEO: {
				return <VideoDialogContent handleClose={handleClose} />;
			}
			case DialogContentType.INFO: {
				return <InfoDialogContent handleClose={handleClose} />;
			}
			case DialogContentType.CONTACT:
			default: {
				return <ContactDialogContent handleClose={handleClose} />;
			}
		}
	};

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			PaperProps={{ square: true }}
			style={{ zIndex: 1220 }} // below the quick menu at 1300
			fullWidth={true}
			maxWidth={'lg'}
			classes={{ paper: classes.dialogPaper }}
		>
			{getDialogContent(activeEntry)}
		</Dialog>
	);
};
